import { render } from "./Heatmap.vue?vue&type=template&id=505c816a"
import script from "./Heatmap.vue?vue&type=script&lang=js"
export * from "./Heatmap.vue?vue&type=script&lang=js"

import "./Heatmap.vue?vue&type=style&index=0&id=505c816a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__